import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Entity } from 'src/app/core/models/entity.model';
import { MultilevelItem } from 'src/app/core/models/multilevel-selector.model';
import { User } from 'src/app/core/models/user.model';
import { GazeMapService } from 'src/app/core/services/gaze-map.service';

@Component({
  selector: 'hbo-single-select-multi-level-item',
  templateUrl: './single-select-multi-level-item.component.html',
  styleUrls: ['./single-select-multi-level-item.component.scss']
})
export class SingleSelectMultiLevelItemComponent {
  @Input('userEntity') userEntity!: User | null;
  @Input('item') item!: MultilevelItem | undefined;
  @Input('allSelected') allSelected!: MultilevelItem | undefined;
  @Input('data') data!: MultilevelItem[] | undefined;
  @Input('selected') selected!: boolean | undefined;
  @Input("typeData") typeData!: String;
  @Input("search") search!: string;
  @Input("max") max!: number | undefined;
  dataPartial!: MultilevelItem[] | undefined;
  dataParentsPartial!: MultilevelItem[];

  @Output('callback') callback = new EventEmitter;
  @Output('callbackVisible') callbackVisible = new EventEmitter;
  constructor(
    public gazeMapService: GazeMapService
  ) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges) {
    this.data?.map((item: MultilevelItem) => item.target.entityTypeId < this.max! ? item.opened = true : false);
    this.dataPartial = this.data;
    this.search && this.search.length
      ? this.dataPartial?.map((item: MultilevelItem) => {
        if (item.selected || this.eliminarDiacriticosEs(item.target.name.toLowerCase()).includes(this.eliminarDiacriticosEs(this.search.toLowerCase()))) {
          item.visible = true;
          this.callbackVisible.emit({ 'item': this.item, value: true });
        } else {
          item.visible = false;
          //this.callbackVisible.emit({'item': this.item , value:false});
        }
      })
      : (
        this.data!.map((item: MultilevelItem) => item.visible = true),
        this.callbackVisible.emit({ 'item': this.item, value: true })
      )
  }

  visibleEntity(e: { item: MultilevelItem, value: boolean }) {
    e.item.visible = e.value;
    this.callbackVisible.emit({ 'item': this.item, value: true });
  }

  eliminarDiacriticosEs(_text: string) {
    return _text
      .normalize('NFD')
      .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1")
      .normalize();
  }
  toogle(_item: MultilevelItem) {
    switch (this.typeData) {
      case 'newTeam':
        /*if (_item.target.entityTypeId === this.max) {
          if (!_item.childs!.length && !_item.selected) {
            _item.selected = !_item.selected;
            this.callback.emit(_item);
          } else {
            _item.opened = !_item.opened;
          }
        } else {
          _item.opened = !_item.opened;
        }*/
        if (!_item.childs!.length && !_item.selected) {
          _item.selected = !_item.selected;
          this.callback.emit(_item);
        } else {
          _item.opened = !_item.opened;
        }
        break;
      case 'team':
        /*if (_item.target.entityTypeId === this.userEntity?.roleId) {
          if (!_item.childs!.length && !_item.selected) {
            _item.selected = !_item.selected;
            this.callback.emit(_item);
          } else {
            _item.opened = !_item.opened;
          }
        } else {
          _item.opened = !_item.opened;
        }*/
        if (!_item.childs!.length && !_item.selected) {
          _item.selected = !_item.selected;
          this.callback.emit(_item);
        } else {
          _item.opened = !_item.opened;
        }
        break;
      case 'newUser':
        /*if (_item.target.entityTypeId === this.max) {
          if (!_item.childs!.length && !_item.selected) {
            _item.selected = !_item.selected;
            this.callback.emit(_item);
          } else {
            _item.opened = !_item.opened;
          }
        } else {
          _item.opened = !_item.opened;
        }*/
        if (!_item.childs!.length && !_item.selected) {
          _item.selected = !_item.selected;
          this.callback.emit(_item);
        } else {
          _item.opened = !_item.opened;
        }
        break;
      case 'newTeam':
        /*if (_item.target.entityTypeId === this.max) {
          if (!_item.childs!.length && !_item.selected) {
            _item.selected = !_item.selected;
            this.callback.emit(_item);
          } else {
            _item.opened = !_item.opened;
          }
        } else {
          _item.opened = !_item.opened;
        }*/
        if (!_item.childs!.length && !_item.selected) {
          _item.selected = !_item.selected;
          this.callback.emit(_item);
        } else {
          _item.opened = !_item.opened;
        }
        break;
      case 'user':
        /*if (_item.target.entityTypeId === this.userEntity?.roleId) {
          if (!_item.childs!.length && !_item.selected) {
            _item.selected = !_item.selected;
            this.callback.emit(_item);
          } else {
            _item.opened = !_item.opened;
          }
        } else {
          _item.opened = !_item.opened;
        }*/
        if (!_item.childs!.length && !_item.selected) {
          _item.selected = !_item.selected;
          this.callback.emit(_item);
        } else {
          _item.opened = !_item.opened;
        }
        break;
      case 'reassignPackage':
        console.log(_item);
        if (!_item.childs!.length && !_item.selected && _item.target.entityTypeId !== 2) {
          _item.selected = !_item.selected;
          this.callback.emit(_item);
        } else {
          _item.opened = !_item.opened;
        }
      break;
      default:
        if (!_item.childs!.length && !_item.selected) {
          _item.selected = !_item.selected;
          this.callback.emit(_item);
        } else {
          _item.opened = !_item.opened;
        }
        break;
    }
  }

  emitChange() {

  }

  change(e: any, _item: MultilevelItem): void {
    console.log(_item);
    switch (this.typeData) {
      /*case 'newUser':
        if (_item.target.entityTypeId === this.max) {
          this.callback.emit(_item);
        }
        break;*/
      /*case 'user':
        if (_item.target.entityTypeId === this.userEntity?.roleId) {
          this.callback.emit(_item);
        }
        break;*/
      default:
        this.callback.emit(_item);
        break;
    }
  }

  setEntity(e: Event) {
    this.callback.emit(e);
  }
}
